class ScrollListComponent {
    constructor() {
        this.scrollListEl = document.querySelector('.js-scroll-list');
        if (this.scrollListEl === null) return;
        
        this.scrollListContentEl = document.querySelector('.js-scroll-content');
		this.lastScrollTop = 0;
		this.delta = 5;
        this.ticking = false;
        this.navPosTop = 0;
        this.lastGroupIndex = 0;
        this.groupPositions = [];

        this.resize = this.resize.bind(this);

		// Listen for scroll events
        // Poll the scroll funk
        this.scrollGroupEls = this.scrollListEl.querySelectorAll('.js-scroll-group');
        this.navEl = this.scrollListEl.querySelector('.js-scroll-nav');
        this.navItemsEl = this.navEl.querySelectorAll('a');
        window.addEventListener('resize', this.resize);
		window.addEventListener('scroll', (e) => {
			if (!this.ticking) {
				window.requestAnimationFrame(() => {
					this.scroll();
					this.ticking = false;
				});
				this.ticking = true;
			}
        });

        for (let i = 0; i < this.navItemsEl.length; i++) {
            this.navItemsEl[i].addEventListener('click', (e) => {
                e.preventDefault();
                this.scrollTo(
                    (document.body && document.body.scrollTop ? document.body : document.documentElement), 
                    this.groupPositions[i].y - 95,
                    300
                );
            });
        }

        this.resize();
        this.scroll();
    }

    resize() {
        // Get navigation position
        this.navPosTop = getPosition(this.navEl);

        // Store group positions
        this.groupPositions = [];
        for (let i = 0; i < this.scrollGroupEls.length; i++) {
            let el = this.scrollGroupEls[i];
            this.groupPositions.push(
                {
                    id: el.getAttribute('id'),
                    y: getPosition(el),
                }
            );
        }

        function getPosition(el) {
            let bodyRect = (document.documentElement || document.body).getBoundingClientRect(),
                elemRect = el.getBoundingClientRect(),
                offset = elemRect.top - bodyRect.top;

            return offset;
        }
    }

	scroll() {
		// Make sure they scroll more than delta
		if (Math.abs(this.lastScrollTop - window.scrollY) <= this.delta)
			return;
        
		if (window.pageYOffset > (this.navPosTop - 95)) {
            //this.navEl.style.transform = `translateY(${(window.scrollY - this.navPosTop) + 95}px)`;
            this.navEl.classList.add('cfo-scroll-list__nav-fixed');
            this.scrollListContentEl.classList.add('cfo-scroll-list__items-fixed');
        } else {
            this.navEl.classList.remove('cfo-scroll-list__nav-fixed');
            this.scrollListContentEl.classList.remove('cfo-scroll-list__items-fixed');
        }

        for (let i = 0; i < this.groupPositions.length; i++) {
            let group = this.groupPositions[i];
            let selectedCls = 'cfo-scroll-list__nav-item--selected';
            if (window.pageYOffset < group.y) {
                if (this.lastGroupIndex !== i) {
                    this.navItemsEl[this.lastGroupIndex].classList.remove(selectedCls);
                    this.navItemsEl[i].classList.add(selectedCls);
                    this.lastGroupIndex = i;
                }
                break;
            }
        }
    }

    scrollTo(element, to, duration) {
        Math.easeInOutQuad = function (t, b, c, d) {
            t /= d/2;
              if (t < 1) return c/2*t*t + b;
              t--;
              return -c/2 * (t*(t-2) - 1) + b;
        };

        let start = element.scrollTop,
            change = to - start,
            currentTime = 0,
            increment = 20;
            
        let animateScroll = function(){        
            currentTime += increment;
            var val = Math.easeInOutQuad(currentTime, start, change, duration);
            element.scrollTop = val;
            if(currentTime < duration) {
                setTimeout(animateScroll, increment);
            }
        };
        animateScroll();
    }
}

export default ScrollListComponent;
